import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {useForm} from 'react-hook-form'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
// import {ILogin} from 'models/Auth'
import {TextField} from 'helpers/ui-components/form/TextField'
import {IFormField, IReduxStore} from 'models/Common'
import Spinner from 'layout/common/Spinner'
import {
 generateOTP,
 verifyOTP,
} from 'utils/api/auth/registerService'
import {toast} from 'react-toastify'

// type Props = {}

const OtpPage = () => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const authReducer = useSelector(
  (state: IReduxStore) => state.authReducer
 )
 const [loader, setLoader] = useState(false)
 const otpForm = {
  otp: '',
 }
 const length = 6
 const [mobileNo, setMobileNo] = useState('')
 const [otp] = useState<string[]>(Array(length).fill(''))

 const {
  register,
  setFocus,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...otpForm, otp},
 })

 const handleChange = (input: string, index: number) => {
  if (input && index < length - 1) {
   setFocus(`otp.${index + 1}`)
  }

  if (input.length === 0 && index > 0) {
   setFocus(`otp.${index - 1}`)
  }
 }

 const resendOTP = async () => {
  const res = await generateOTP({
   phone_number: authReducer.mobileNo,
   refernce: 'mobile_verification_otp',
  })
  if (res) {
   toast.success(t('otpPage.msgSent'))
  }
 }

 async function submitOTPFormData(formData: IFormField) {
  const otp = formData?.otp
  if (Array.isArray(otp)) {
   setLoader(true)
   const res = await verifyOTP({
    phone_number: authReducer.mobileNo,
    refernce: 'mobile_verification_otp',
    otp: otp?.join(''),
   })
   setLoader(false)
   if (res) {
    navigate('/verify-ac-thank-you-page')
   }
  }
 }

 useEffect(() => {
  if (authReducer) {
   if (authReducer.mobileNo) {
    setMobileNo(authReducer.mobileNo.toString())
   }
  }
 }, [authReducer])

 return (
  <>
   {loader && <Spinner />}
   <div className='container bg-white'>
    <div className='bg-white flex justify-center min-h-full sm:pt-3 md:pt-14 sm:px-2'>
     <div className='relative sm:w-full md:w-[360px] '>
      <div className='border-b border-b-[#CED8E0] w-full text-left pb-2 pt-4'>
       <span className='text-[#33393D] text-lg font-bold'>
        {t('otpPage.title')}
       </span>
      </div>
      <div className='my-8 text-left text-lg font-medium'>
       <span className='text-[##666666]'>
        {t('otpPage.msgSent')}{' '}
        {`"******${mobileNo.substr(mobileNo.length - 4)}"`}
       </span>
      </div>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitOTPFormData)}
      >
       <div className='relative w-full my-8'>
        <div className='relative w-full'>
         <div className={`grid grid-cols-${length} gap-5`}>
          {Array.from({length}, (_, index) => (
           <TextField
            key={index}
            type='tel'
            inputMode='numeric'
            pattern='[0-9]*'
            className='relative text-[#171B1F] !text-2xl !px-0 !font-medium block items-center'
            wrapperClassName='relative w-full'
            inputWrapperClassName='!w-[50px] !h-[64px] text-center flex items-center'
            required={false}
            id={`otp.${index}`}
            name={`otp.${index}`}
            placeholder={'_'}
            minLength={1}
            maxLength={1}
            register={register(`otp.${index}`, {
             validate: {
              regex: (v: string) => {
               if (v !== '' && !v?.match('^[0-9]{1}$'))
                return ``
              },
              required: (v: string) => {
               if (v === '') return ``
              },
             },
             onChange: (e: {target: {value: string}}) =>
              handleChange(e.target.value, index),
            })}
            errors={errors}
           />
          ))}
         </div>
         {errors && Object.keys(errors).length !== 0 && (
          <p className='error-msg error-cls'>
           {t('otpPage.otpErrorMsg')}
          </p>
         )}
        </div>
       </div>
       <div className='md:flex items-center justify-center w-full mt-8'>
        <Button
         disabled={
          errors && Object.keys(errors).length !== 0
         }
         type='submit'
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                  !rounded-lg !text-base text-white font-semibold'
        >
         {t('otpPage.continue')}
        </Button>
       </div>
      </form>
      <div className='my-8 text-center text-lg font-normal'>
       <span className='text-[#808080]'>
        {t('otpPage.didNotReceiveCode')}?{' '}
       </span>
       <button
        className='text-[#4E83E4] '
        onClick={resendOTP}
       >
        {t('otpPage.resend')}
       </button>
      </div>
     </div>
    </div>
   </div>
  </>
 )
}

export default function OtpPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   {/* <PageTitle
        breadcrumbs={[{title: 'sdf', path: 'login', isActive: false}]}
        description='Welcome'
      >
        Welcome Page
      </PageTitle> */}
   <OtpPage />
  </>
 )
}
